import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { mapFramesizeFacetToLabelKeys } from '@grandvisionhq/utils';
import { TileLayout } from '../TileLayout/TileLayout.js';

const FrameSizeText = ({ facetTerm  })=>{
    const { getLabel  } = useIntl();
    const keys = mapFramesizeFacetToLabelKeys(facetTerm);
    const title = getLabel((keys === null || keys === void 0 ? void 0 : keys.title) || '') || `${facetTerm}`;
    const subtitle = getLabel((keys === null || keys === void 0 ? void 0 : keys.subtitle) || '');
    return /*#__PURE__*/ React.createElement(TileLayout, {
        title: title,
        subtitle: subtitle
    });
};

export { FrameSizeText };
//# sourceMappingURL=FrameSizeText.js.map
